import React from "react";
import {connect} from "react-redux";
import {Redirect, Route, Router, Switch} from "react-router-dom";
import {bindActionCreators, Dispatch} from "redux";
import AppLayout from "./containers/AppLayout/AppLayout";
import HomePage from "./containers/HomePage/HomePage";
import {appFetchAndActivateRemoteConfig, appSetApiError, appSetPathname,} from "./core/actions/app";
import axios from "./core/helpers/axios";
import {history} from "./core/helpers/history";
import {router} from "./core/helpers/router";
import {ErrorDto, ErrorGeneric, getErrorDtoFromApiError} from "./core/models/dtos/error.dto";
import {IStore} from "./core/reducers";
import {AppState} from "./core/types/app";

interface IProps {
  loadingFirebase: boolean;
  appFetchAndActivateRemoteConfig: () => void;
  appSetPathname: (pathname: string) => void;
  appSetApiError: (errorDto: ErrorDto) => void;
}

interface IState {
  callbackHistoryUnregister?: VoidFunction;
}

class App extends React.Component<IProps> {
  state: IState = {
    callbackHistoryUnregister: undefined,
  }

  constructor(props: IProps) {
    super(props);
    this.setAxiosInterceptor();
    this.props.appFetchAndActivateRemoteConfig();
  }

  componentDidMount() {
    this.setHistoryListener();
  }

  private setAxiosInterceptor(): void {
    axios.interceptors.response.use(
      response => response,
      async error => {
        if (!error.response || error.response.status === 500) {
          this.props.appSetApiError(ErrorGeneric);
        } else {
          const errorDto = getErrorDtoFromApiError(error);
          this.props.appSetApiError(errorDto);
        }
        return Promise.reject(error);
      }
    );
  }

  private setHistoryListener(): void {
    const callbackHistoryUnregister = history.listen((location: any, _: any) => {
      this.props.appSetPathname(location.pathname);
    });
    this.setState({callbackHistoryUnregister});
  }

  private isAppLoading(): boolean {
    return (
      this.props.loadingFirebase
    );
  }

  render() {
    return (
      this.isAppLoading()
        ?
        <React.Fragment/>
        :
        <Router history={history}>
          <AppLayout>
            <Switch>
              <Route exact path={router.HOME} component={HomePage}/>
              <Redirect to={router.HOME}/>
            </Switch>
          </AppLayout>
        </Router>
    );
  }

  componentWillUnmount() {
    if (this.state.callbackHistoryUnregister) {
      this.state.callbackHistoryUnregister();
    }
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      appFetchAndActivateRemoteConfig,
      appSetPathname,
      appSetApiError,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  const state: AppState = store.app;
  return {
    loadingFirebase: state.loadingFirebase,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
